export const MISSING_CATEGORY_AND_ACTION = 'Category and action must be specified';
export const MISSING_CUSTOM_PARAMS = 'Custom parameters must be specified';
export const JSON_INVALID = 'Could not parse JSON';
export const CLIPBOARD_UNSUPPORTED = 'Clipboard is not supported';
export const REQUIRED_ELEMENTS_NOT_FOUND = 'Could not find all required elements';
export const FIELD_HAS_ERRORS = 'message.jsModules.constants.errors.fieldHasErrors';
export const FIELD_IS_REQUIRED = 'message.jsModules.constants.errors.fieldIsRequired';
export const FIELD_DOES_NOT_MATCH = 'message.jsModules.constants.errors.fieldMustMatchAnotherField';
export const COUNTRY_NOT_FOUND = 'message.jsModules.constants.errors.countryNotFound';
